// Shared utility functions for activity components

/**
 * Format time in seconds to MM:SS format
 * @param {number} seconds - Time in seconds
 * @returns {string} Formatted time string
 */
export const formatTime = (seconds) => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
};

/**
 * Convert YouTube URL to embed URL
 * @param {string} youtubeUrl - YouTube URL
 * @returns {string} Embed URL
 */
export const getEmbedUrl = (youtubeUrl) => {
  const videoIdMatch = youtubeUrl.match(
    /(?:youtube\.com\/(?:watch\?v=|)([a-zA-Z0-9_-]+))/
  );

  if (videoIdMatch && videoIdMatch[1]) {
    const videoId = videoIdMatch[1];
    return `https://www.youtube.com/embed/${videoId}`;
  } else {
    return youtubeUrl;
  }
};

/**
 * Calculate total marks and questions from activity data
 * @param {Array} questions - Array of question objects
 * @returns {Object} Object containing totalMarks and totalQuestions
 */
export const calculateActivityStats = (questions) => {
  let totalMarks = 0;
  let totalQuestions = 0;
  
  questions.forEach(data => {
    totalMarks += data.marks || 0;
    totalQuestions++;
  });
  
  return { totalMarks, totalQuestions };
};

/**
 * Generate remarks based on percentage score
 * @param {number} percentage - Score percentage
 * @returns {string} Remark text
 */
export const generateRemarks = (percentage) => {
  if (percentage > 90) return 'Excellent Work';
  if (percentage > 70) return 'Good Job';
  return 'Try Again';
};

/**
 * Get activity route based on activity type
 * @param {string} activityType - Type of activity
 * @returns {string} Route path
 */
export const getActivityRoute = (activityType) => {
  const routes = {
    'Video': '/VideoActivity',
    'Game': '/GameActivity',
    'Mental': '/MentalActivity',
    'Oral': '/OralActivity',
    'Written': '/WrittenActivity',
    'Speed Quiz': '/SpeedQuizActivity',
    'MCQ': '/MCQActivity',
    'Exam': '/ExamActivity'
  };
  
  return routes[activityType] || '/';
};
